import { Instances } from 'src/containers/Instances';
import { PageGuard } from 'src/pages/PageGuard';
import { PAGES_CONFIG } from '../config';

export const InstancesPage = () => (
  <PageGuard hasAccess={PAGES_CONFIG.instances.hasAccess}>
    <Instances />
  </PageGuard>
);
